import { createSlice } from '@reduxjs/toolkit';

import { resetOnLogOutMatcher } from 'src/services/auth';
import { collectionApi } from './api';
import { CollectionState } from './types';

const initialState = {
  deletedCollections: {},
} as CollectionState;

export const collectionSlice = createSlice({
  extraReducers: (builder) =>
    builder
      .addMatcher(
        collectionApi.endpoints.deleteCollection.matchFulfilled,
        (state, action) => ({
          ...state,
          deletedCollections: {
            ...state.deletedCollections,
            [action.meta.arg.originalArgs.id]: true,
          },
        }),
      )
      .addMatcher(...resetOnLogOutMatcher(initialState)),
  initialState,
  name: 'collection',
  reducers: {},
});
